/**
 * Created by Administrator on 2017/10/27.
 */
import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
import {HttpService} from "../service/http-service";
import {CommonService} from "../service/common";
import {FileUpload} from "../service/file-upload";
import {API} from "../config/api-config";
declare var alertify:any;
declare var $:any;
@Component({
  templateUrl:'./trackingNumberEdit.html'
})

export class TrackingNumberEdit implements OnInit{
  constructor(
    private router:Router,
    private route:ActivatedRoute,
    private HttpService:HttpService,
    private fileupload:FileUpload,
    private location:Location,
    private common:CommonService
  ){}


  private data:any={
    "open":"",
    "url": ""

  }

  private id:number = 0;
  private isCreate:boolean=false;
  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id=params['id'];
    });

    if(this.id!=0){
      this.getData();
    }else {
      this.isCreate=true;
    }
  }

  private getData():void{
    this.HttpService.getData(API.trackingNumber).then(res=>{
      this.data = res.data;

    })
  }


  private submit():void{
    this.HttpService.postData(API.trackingNumber,{
      "open":this.data.open,
      "url": this.data.url

    }).then(res=>{
      let data=res;
      if(data.status.code==0 || data.status.code=='0'){
        this.location.back();
        alertify.success(data.status.message);
      }else{
        alertify.error(data.status.message);
      }
    });
  }

}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/trackingNumber/trackingNumberEdit.component.ts